const elevateInfo = { version: '1.9.1' };
export default elevateInfo;
